import {Trans} from '@common/i18n/trans';
import {useLandingPageStats} from '@app/landing/use-landing-page-stats';
import {LinkIcon} from '@common/icons/material/Link';
import {cloneElement, ReactElement} from 'react';
import {SvgIconProps} from '@common/icons/svg-icon';
import {MouseIcon} from '@common/icons/material/Mouse';
import {PersonIcon} from '@common/icons/material/Person';
import {FormattedNumber} from '@common/i18n/formatted-number';

export function LandingPageStats() {
  const {data} = useLandingPageStats();

  if (!data) return null;

  return (
    <div className="landing-container grid gap-24 border-t py-64 sm:grid-cols-3 md:gap-40 md:py-90">
      <StatLayout
        label={<Trans message="Total links shortened" />}
        icon={<LinkIcon />}
        number={data.stats.links}
      />
      <StatLayout
        label={<Trans message="Total link clicks" />}
        icon={<MouseIcon />}
        number={data.stats.clicks}
      />
      <StatLayout
        label={<Trans message="Users signed up" />}
        icon={<PersonIcon />}
        number={data.stats.users}
      />
    </div>
  );
}

interface StatLayoutProps {
  label: ReactElement;
  icon: ReactElement<SvgIconProps>;
  number: number;
}
function StatLayout({label, icon, number}: StatLayoutProps) {
  return (
    <div className="flex min-w-0 items-center">
      {cloneElement(icon, {size: 'xl'})}
      <div className="ml-18 min-w-0 border-l border-l-2 pl-18 md:ml-24 md:pl-24">
        <div className="text-sm uppercase leading-5 sm:text-[15px]">
          {label}
        </div>
        <div className="mt-6 text-3xl font-medium">
          <FormattedNumber value={number} />
        </div>
      </div>
    </div>
  );
}
